export { Waitlist } from './waitlist.component';
